import { ButtonProps } from 'blaze-ui/Button/Types'
import { VoiceData } from 'hooks/useBrandVoices'
import { ReactComponent } from 'react-hotkeys'

export enum Tone {
  Conversational = 'Conversational',
  Friendly = 'Friendly',
  Funny = 'Funny',
  Persuasive = 'Persuasive',
  Compelling = 'Compelling',
  Assertive = 'Assertive',
  Professional = 'Professional',
  Informative = 'Informative',
  Courteous = 'Courteous',
  Empathetic = 'Empathetic',
  Emotive = 'Emotive',
  Engaging = 'Engaging',
  Clear = 'Clear',
  Concise = 'Concise',
}

export enum MenuItemType {
  Voice = 'Voice',
  Tone = 'Tone',
}

export type MenuItemKey = `${MenuItemType}:${string}`

export interface BaseMenuItem<ID, Type extends MenuItemType, Item> {
  id: ID
  type: Type
  value: Item
  key: MenuItemKey
}

export type VoiceMenuItem = BaseMenuItem<number, MenuItemType.Voice, VoiceData>

export type ToneMenuItem = BaseMenuItem<string, MenuItemType.Tone, Tone>

export type MenuItem = VoiceMenuItem | ToneMenuItem

export interface VoiceAndTonesSelectProps extends Pick<ButtonProps, 'size'> {
  onVoiceSelect: (id?: number) => void
  onToneSelect: (tone: Tone) => void
  selectedVoiceIds: number[]
  selectedTones: Tone[]
  disabledTones?: Tone[]
  disabledVoiceIds?: number[]
  voices: VoiceData[]
  tones: Tone[]
  label?: string
  ButtonComponent?: ReactComponent
  popoverClassName?: string
}
